import { render, staticRenderFns } from "./ContactSearch.vue?vue&type=template&id=22e1a2c4&scoped=true&"
import script from "./ContactSearch.vue?vue&type=script&lang=js&"
export * from "./ContactSearch.vue?vue&type=script&lang=js&"
import style0 from "./ContactSearch.vue?vue&type=style&index=0&id=22e1a2c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e1a2c4",
  null
  
)

export default component.exports